import { isAfter } from 'date-fns';

/**
 * Transforms a activity booking part fulfillments into a refundable for activities.
 */
export function transformRefundableActivity(
    activity: ApiSchema['Activity'],
    apiBooking: ApiSchema['Booking'],
): RefundableActivity {
    const passengers = apiBooking.passengers
        .filter(p => activity?.passengerIds.includes(p.id))
        .map(p => transformPassenger(p));
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === activity.id));
    const dateFrom = zurichDate(activity.validFrom);
    const dateUntil = zurichDate(activity.validUntil);
    const id = activity.id;
    const fulfillmentId = fulfillment?.id;
    const type = 'Activity';
    const summaryLine1 = passengers.map(p => `${p.firstName} ${p.lastName}`).join(', ');
    const summaryLine2 = passengers.map(p => `*${formatMonthMediumYear(p.dateOfBirth)}`).join(', ');
    const detailLine1 = activity.summary ?? '';
    const detailLine2 = formatDateFromTo(dateFrom, dateUntil, true);
    const status = activity.status;
    const price = activity.price;
    const refundConditionDate = activity.afterSaleConditions?.find(c => c.condition === 'REFUND')?.validUntil;
    const refundDeadline = refundConditionDate ? zurichDate(refundConditionDate) : undefined;
    const isExpired = refundDeadline ? isAfter(zurichDate(), refundDeadline) : false;
    const isRefunded = activity.status === 'REFUNDED';
    const isRefundable = !!refundDeadline && activity.status === 'FULFILLED' && !isExpired;

    return {
        id,
        fulfillmentId,
        type,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        status,
        price,
        refundDeadline,
        isExpired,
        isRefunded,
        isRefundable,
    };
}
